module.exports = __webpack_public_path__ + "static/media/officeImg5.dcee879b.png";